/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */

import {useTranslation} from "react-i18next"; // Importing translation hook for internationalization
import {useDispatch, useSelector} from "react-redux"; // Importing Redux hooks to interact with the store
import {useState} from "react"; // Importing React's useState hook to manage local state
import {DeleteItemsApi} from "../../../../../reduxToolkit/Commons/CommonsApi"; // Importing the API function for deleting items

// NotificationPanelApp component manages the logic for deleting notifications
const NotificationPanelApp = () => {
    const { t } = useTranslation(); // Translation function to handle text localization
    const dispatch = useDispatch(); // Dispatch function to send actions to the Redux store
    const { permission } = useSelector((state) => state.authenticatioauthennSlice); // Getting user permissions from Redux store
    const DEV = useSelector((state) => state?.CommonsSlice?.development); // Checking if the application is in development mode
    const [contractorId, setContractorId] = useState(sessionStorage.getItem('contractorId'));
    const [supplierId, setSupplierId] = useState(sessionStorage.getItem('providerId'));
    const [selectAnnouncementForDelete, setSlectAnnouncementForDelete] = useState([]); // State for storing selected announcements to delete
    const [isAllChecked, setIsAllChecked] = useState(false); // State to track if all checkboxes are selected
    const [deleteAnnouncementShow, setDeleteAnnouncementShow] = useState(false); // State to show or hide the delete confirmation
    const [modified, setModified] = useState(false); // State to track if there have been any modifications (e.g., deletion)
    const [expandImage, setExpandImage] = useState(''); // State to handle image expansion (not used directly in the code provided)

    // Function to delete the selected announcements
    const deleteAnnouncement = (selectAnnouncementForDelete) => {
        const tableName = 'announcement'; // Table name to specify which resource to delete
        const body = selectAnnouncementForDelete; // The list of selected announcement IDs to delete

        // Check if there are any announcements selected for deletion
        if (body.length > 0) {
            // Dispatch the DeleteItemsApi action to delete the selected items
            dispatch(DeleteItemsApi({ tableName, body })).then(
                ({
                     payload: {
                         data: { success }, // Get success status from the API response
                     },
                 }) => {
                    if (success === true) {
                        // If deletion is successful, reset state to reflect the changes
                        setDeleteAnnouncementShow(false); // Hide the delete confirmation
                        setModified(true); // Mark that the notifications have been modified
                        setIsAllChecked(false); // Uncheck the "select all" checkbox
                        setSlectAnnouncementForDelete([]); // Clear selected announcements for deletion
                    }
                },
            );
        }
    };

    // Return the necessary state and functions to be used by the component
    return {
        t, // Translation function for text localization
        DEV, // Development mode flag
        permission, // User's permissions
        contractorId,
        supplierId,
        modified, // Flag indicating whether the data has been modified (e.g., after deletion)
        setModified, // Function to update the modified state
        expandImage, // State for expanded image (currently not used)
        setExpandImage, // Function to update the expanded image state
        selectAnnouncementForDelete, // List of selected announcements for deletion
        setDeleteAnnouncementShow, // Function to update the delete confirmation state
        isAllChecked, // State for tracking if "select all" checkbox is checked
        setIsAllChecked,
        deleteAnnouncementShow, // State for showing the delete confirmation dialog
        setSlectAnnouncementForDelete, // Function to update the selected announcements for deletion
        deleteAnnouncement, // Function to delete selected announcements
    };
}

export default NotificationPanelApp; // Export the component to be used in other parts of the app
